// api.js

import axios from 'axios';

const headers = {
    "X-localization": localStorage.getItem("lan"),
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Max-Age": 3600,
  };

export const fetchSessionDropdown = async () => {
  try {
    const response = await axios.get(
      "https://sass.britishstandardschool.com/api/Public/SessionDropDown"
    );
    const sessionresponse = response.data;
    console.log(sessionresponse);
    return sessionresponse; // Return the fetched data
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
    } else {
      console.error(`Error: ${err.message}`);
    }
    throw err; // Rethrow the error
  }
};

export const OnlineAdmissionList = async () => {
    try {
      const response = await axios.get(
        "https://sass.britishstandardschool.com/api/Admin/AdmissionList", {},
        headers
      );
      return response
      //sass.britishstandardschool.com
    //   const manageonlineadmissionresponse = response.data[0];
    //   console.log(manageonlineadmissionresponse)
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
        console.log(err.response.status);
        console.log(err.response.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  };


 export function OnlineAdmissinReview(admId) {
    try {
      axios.get(
        "https://sass.britishstandardschool.com/api/Admin/ReviewOnlineAdmission" + admId,
        {},
        headers
      ).then(function (response) {
        return response
        
      });
    } catch (err) {
      if (err.response) {
        console.error(err.response.data);
        console.log(err.response.status);
        console.log(err.response.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  }

  export const fetchClassDropdown = async () => {
    try {
      const classresponse = await axios.get(
        "https://sass.britishstandardschool.com/api/Public/ClassList",
        {},
        headers
      );
      return classresponse;
      
    } catch (err) {
      if (err.classresponse) {
        console.error(err.classresponse.data);
        console.log(err.classresponse.status);
        console.log(err.classresponse.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  };
  export const fetchsectionDropdown = async () => {
    try {
      const sectionresponse = await axios.get(
        "https://localhost:7229/api/Public/SectionDropDown",
        {},
        headers
      );
      return sectionresponse.data;
    } catch (err) {
      if (err.sectionresponse) {
        console.error(err.sectionresponse.data);
        console.log(err.sectionresponse.status);
        console.log(err.sectionresponse.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  };

  export const fetchGenderDropdown = async () => {
    try {
      const genderresponse = await axios.get(
        "https://sass.britishstandardschool.com/api/Public/GenderDropDown",
        {},
        headers
      );
      return genderresponse.data;
      
    } catch (err) {
      if (err.genderresponse) {
        console.error(err.genderresponse.data);
        console.log(err.genderresponse.status);
        console.log(err.genderresponse.header);
      } else {
        console.error(`Error: ${err.message}`);
      }
    }
  };
  export  const fetchShitDropdown = async () => {
    try {
        const shiftresponse = await axios.get(
            "https://localhost:7229/api/Public/ShiftDropDown",
            {},
            headers
        );
        return shiftresponse.data;
       //console.log(shiftresponse);
    } catch (err) {
        if (err.shiftresponse) {
            console.error(err.shiftresponse.data);
            console.log(err.shiftresponse.status);
            console.log(err.shiftresponse.header);
        } else {
            console.error(`Error: ${err.message}`);
        }
    }
};
  export  const fetchNoticeTypeDropdown = async () => {
    try {
        const noticetyperesponse = await axios.get(
            "https://localhost:7229/api/Admin/NoticeTypeDropDown",
            {},
            headers
        );
        return noticetyperesponse.data;
       //console.log(shiftresponse);
    } catch (err) {
        if (err.shiftresponse) {
            console.error(err.shiftresponse.data);
            console.log(err.shiftresponse.status);
            console.log(err.shiftresponse.header);
        } else {
            console.error(`Error: ${err.message}`);
        }
    }
};
  export  const fetchNoticeForDropdown = async () => {
    try {
        const noticeforresponse = await axios.get(
            "https://localhost:7229/api/Admin/NoticeForDropDown",
            {},
            headers
        );
        return noticeforresponse.data;
       //console.log(shiftresponse);
    } catch (err) {
        if (err.shiftresponse) {
            console.error(err.shiftresponse.data);
            console.log(err.shiftresponse.status);
            console.log(err.shiftresponse.header);
        } else {
            console.error(`Error: ${err.message}`);
        }
    }
};

  export const fetchCampusDropdown = async () => {
    try {
        const campusresponse = await axios.get(
            "https://localhost:7229/api/Public/CampusDropDown",
            {},
            headers
        );
        return campusresponse.data;
    } catch (err) {
        if (err.campusresponse) {
            console.error(err.campusresponse.data);
            console.log(err.campusresponse.status);
            console.log(err.campusresponse.header);
        } else {
            console.error(`Error: ${err.message}`);
        }
    }
};
export const fetchCountryDropdown = async () => {
  try {
      const countryresponse = await axios.get(
          "https://localhost:7229/api/Public/CountryDropDown",
          {},
          headers
      );
      return countryresponse.data;
  } catch (err) {
      if (err.countryresponse) {
          console.error(err.countryresponse.data);
          console.log(err.countryresponse.status);
          console.log(err.countryresponse.header);
      } else {
          console.error(`Error: ${err.message}`);
      }
  }
};
export const fetchdivisionDropdown = async () => {
  try {
    const divisionresponse = await axios.get(
      "https://localhost:7229/api/Public/DivisionDropDown",
      {},
      headers
    );
    return divisionresponse.data;
  } catch (err) {
    if (err.divisionresponse) {
      console.error(err.divisionresponse.data);
      console.log(err.divisionresponse.status);
      console.log(err.divisionresponse.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchdistrictDropdown = async () => {
  try {
    const districtresponse = await axios.get(
      "https://localhost:7229/api/Public/DistrictDropDown",
      {},
      headers
    );
    return districtresponse.data;
  } catch (err) {
    if (err.districtresponse) {
      console.error(err.districtresponse.data);
      console.log(err.districtresponse.status);
      console.log(err.districtresponse.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};

export const fetchthanaDropdown = async () => {
  try {
    const thanaresponse = await axios.get(
      "https://localhost:7229/api/Public/ThanaDropDown",
      {},
      headers
    );
    return thanaresponse.data;
  } catch (err) {
    if (err.thanaresponse) {
      console.error(err.thanaresponse.data);
      console.log(err.thanaresponse.status);
      console.log(err.thanaresponse.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};

export const fetchnationalityDropdown = async () => {
  try {
    const nationalityresponse = await axios.get(
      "https://localhost:7229/api/Public/NationalityDropDown",
      {},
      headers
    );
    return nationalityresponse.data;
  } catch (err) {
    if (err.nationalityresponse) {
      console.error(err.nationalityresponse.data);
      console.log(err.nationalityresponse.status);
      console.log(err.nationalityresponse.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchreligionDropdown = async () => {
  try {
    const religionresponse = await axios.get(
      "https://localhost:7229/api/Public/ReligionDropDown",
      {},
      headers
    );
    return religionresponse.data;
  } catch (err) {
    if (err.religionresponse) {
      console.error(err.religionresponse.data);
      console.log(err.religionresponse.status);
      console.log(err.religionresponse.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchbloodgroupDropdown = async () => {
  try {
    const bloodgroupresponse = await axios.get(
      "https://localhost:7229/api/Public/BloodGroupDropDown",
      {},
      headers
    );
    return bloodgroupresponse.data;
  } catch (err) {
    if (err.bloodgroupresponse) {
      console.error(err.bloodgroupresponse.data);
      console.log(err.bloodgroupresponse.status);
      console.log(err.bloodgroupresponse.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchEmpGenderDropDownn = async () => {
  try {
    const GenderResponse = await axios.get(
      "https://localhost:7229/api/Public/EmpGenderDropDown",
      {},
      headers
    );
    return GenderResponse.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchMaritalStatusDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Public/MaritalStatusDrpDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchDesignationTypeDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Public/DesignationTypeDrpDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchDepartmentTypeDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Public/DepartmentTypeDrpDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchUnitTypeDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Public/UnitTypeDrpDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchCompanyTypeDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Public/CompanyTypeDrpDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchPersonTypeDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Public/PersonTypeDrpDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};

export const fetchQulificationDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/EmployeeEntry/QulificationDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchSubjectDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/EmployeeEntry/SubjectListDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchInstituteDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/EmployeeEntry/InstituteDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchBoardDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/EmployeeEntry/BoardDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchCompanyDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/EmployeeEntry/CompanyDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchPositionDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/EmployeeEntry/PositionDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchSessionStatusDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Admin/SessionStatusDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchPeriodNameDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Admin/GetCurrentSessionPeriod",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchPeriodStatusDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Admin/PeriodStatusDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};

export const fetchPeriodAlertStatusDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Admin/PeriodAlertStatusDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchFlexSetDrpDown = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Admin/FlexSetSelectDropDown",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchCampusList = async () => {
  try {
    const response = await axios.get(
      "https://localhost:7229/api/Admin/CampusList",
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchSubjectList = async () => {
  try {
    const response = await axios.get(
      'https://localhost:7229/api/Admin/SubjectList',
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};
export const fetchNoticeList = async () => {
  try {
    const response = await axios.get(
      'https://localhost:7229/api/Admin/NoticeList',
      {},
      headers
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      console.error(err.response.data);
      console.log(err.response.status);
      console.log(err.response.header);
    } else {
      console.error(`Error: ${err.message}`);
    }
  }
};





 